import { render, staticRenderFns } from "./questionPaperList.vue?vue&type=template&id=9b277248&scoped=true&"
import script from "./questionPaperList.vue?vue&type=script&lang=js&"
export * from "./questionPaperList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b277248",
  null
  
)

export default component.exports